(() => {
  const initMembershipLegal = () => {
    document.querySelectorAll('.kuf-payment-card').forEach((root, index) => {
      if (root.dataset.kufLegalReady === 'true') return;

      const termsLink = root.querySelector('a[href="/pages/villkor"], a[href$="/pages/villkor"]');
      const privacyLink = root.querySelector('a[href="/pages/integritet"], a[href$="/pages/integritet"]');
      if (!termsLink || !privacyLink) return;

      root.dataset.kufLegalReady = 'true';
      const baseId = (root.id || `kuf-membership-${index + 1}`).replace(/[^a-zA-Z0-9_-]/g, '-');
      const termsId = `${baseId}-membership-terms`;
      const privacyId = `${baseId}-privacy-policy`;

      const disclosures = document.createElement('div');
      disclosures.className = 'kuf-legal-disclosures';
      disclosures.innerHTML = `
        <section class="kuf-legal-panel" id="${termsId}" data-kuf-legal-panel="terms" hidden aria-labelledby="${termsId}-title">
          <header class="kuf-legal-panel__header">
            <div>
              <p class="kuf-legal-panel__eyebrow">KUF Gävle</p>
              <h3 id="${termsId}-title" tabindex="-1">Medlemsvillkor</h3>
            </div>
            <button class="kuf-legal-panel__close" type="button" data-kuf-legal-close aria-label="Stäng medlemsvillkoren">×</button>
          </header>
          <div class="kuf-legal-panel__content">
            <section><h4>1. Ansökan och behörighet</h4><p>Medlemskapet är personligt och gäller för personer som är 18–35 år. Du ansvarar för att uppgifterna i ansökan är riktiga och att medlemsfotot föreställer dig.</p></section>
            <section><h4>2. Avgift och godkännande</h4><p>Årsmedlemskapet kostar 199 kr. Betalningen innebär att ansökan skickas in, men medlemskapet blir aktivt först när styrelsen har granskat och godkänt den. Om ansökan avslås återbetalas det erlagda medlemsbeloppet till samma betalningssätt.</p></section>
            <section><h4>3. Giltighetstid</h4><p>Medlemskapet gäller i 12 månader från godkännandedatumet. Förnyelse sker genom en ny betalning och, när det behövs, en uppdaterad medlemsansökan.</p></section>
            <section><h4>4. Medlemskort och förmåner</h4><p>Det digitala medlemskortet, medlemsnumret och eventuella medlemsförmåner får endast användas av den registrerade medlemmen och får inte överlåtas.</p></section>
            <section><h4>5. Medlemskap + kickoff</h4><p>Paketet innehåller ett årsmedlemskap och en personlig kickoffbiljett. Biljetten är knuten till den person som anges i ansökan och kan kontrolleras tillsammans med legitimation vid entrén.</p></section>
            <section><h4>6. Uppförande och stadgar</h4><p>Medlemmar ska följa KUF Gävles stadgar, värdegrund och ordningsregler. Styrelsen hanterar avslag, avstängning eller avslut av medlemskap i enlighet med stadgarna.</p></section>
            <section class="kuf-legal-panel__contact"><h4>Frågor om villkoren</h4><p>Kontakta KUF Gävle på <a href="mailto:kufgefle@gmail.com">kufgefle@gmail.com</a>.</p></section>
          </div>
        </section>

        <section class="kuf-legal-panel" id="${privacyId}" data-kuf-legal-panel="privacy" hidden aria-labelledby="${privacyId}-title">
          <header class="kuf-legal-panel__header">
            <div>
              <p class="kuf-legal-panel__eyebrow">Dataskydd</p>
              <h3 id="${privacyId}-title" tabindex="-1">Integritetspolicy</h3>
            </div>
            <button class="kuf-legal-panel__close" type="button" data-kuf-legal-close aria-label="Stäng integritetspolicyn">×</button>
          </header>
          <div class="kuf-legal-panel__content">
            <section><h4>1. Personuppgiftsansvarig</h4><p>KUF Gävle ansvarar för behandlingen av personuppgifter som lämnas i medlemsansökan, vid biljettköp och på medlemssidan.</p></section>
            <section><h4>2. Uppgifter som behandlas</h4><ul><li>namn, e-postadress, telefonnummer, födelsedatum och ort,</li><li>medlemsfoto, medlemsnummer och medlemsstatus,</li><li>valt paket, order- och betalningsuppgifter samt eventbiljett,</li><li>övrig information som du själv lämnar i ansökan.</li></ul></section>
            <section><h4>3. Varför uppgifterna används</h4><p>Uppgifterna används för att granska ansökan, administrera medlemskapet, kontrollera ålderskravet, skapa medlemskort och personlig biljett, hantera betalning, bokföring, medlemskommunikation och säker entré till aktiviteter.</p></section>
            <section><h4>4. Rättslig grund</h4><p>Behandlingen sker för att administrera ditt medlemskap och fullgöra föreningens åtaganden, följa rättsliga skyldigheter samt tillgodose berättigade intressen som säker administration. Medlemsfotot behandlas med stöd av det samtycke som lämnas i ansökan.</p></section>
            <section><h4>5. Vem får tillgång?</h4><p>Endast behöriga styrelsemedlemmar och nödvändiga tjänsteleverantörer, exempelvis Shopify och betalningsleverantörer, får tillgång när det krävs för tjänsten. KUF Gävle säljer inte personuppgifter.</p></section>
            <section><h4>6. Lagring</h4><p>Uppgifterna sparas så länge medlemskapet administreras och därefter endast så länge det behövs för rättsliga skyldigheter, bokföring, säkerhet eller eventuella rättsliga anspråk. Uppgifter som inte längre behövs raderas eller anonymiseras.</p></section>
            <section><h4>7. Dina rättigheter</h4><p>Du kan begära tillgång, rättelse, radering eller begränsning, invända mot viss behandling och återkalla ett samtycke. Du har även rätt att lämna klagomål till Integritetsskyddsmyndigheten.</p></section>
            <section class="kuf-legal-panel__contact"><h4>Kontakt i integritetsfrågor</h4><p>Skicka din begäran till <a href="mailto:kufgefle@gmail.com">kufgefle@gmail.com</a>. KUF Gävle kan behöva kontrollera din identitet innan uppgifter lämnas ut eller ändras.</p></section>
          </div>
        </section>`;

      const consentRows = root.querySelectorAll('.kuf-payment-consent');
      const insertionPoint = consentRows[consentRows.length - 1];
      if (!insertionPoint) return;
      insertionPoint.insertAdjacentElement('afterend', disclosures);

      const links = { terms: termsLink, privacy: privacyLink };
      const panels = {
        terms: disclosures.querySelector('[data-kuf-legal-panel="terms"]'),
        privacy: disclosures.querySelector('[data-kuf-legal-panel="privacy"]')
      };

      const closePanel = (key) => {
        const panel = panels[key];
        if (!panel) return;
        panel.hidden = true;
        panel.classList.remove('is-open');
        links[key].setAttribute('aria-expanded', 'false');
      };

      const openPanel = (key) => {
        Object.keys(panels).forEach((panelKey) => {
          if (panelKey !== key) closePanel(panelKey);
        });
        const panel = panels[key];
        panel.hidden = false;
        panel.classList.add('is-open');
        links[key].setAttribute('aria-expanded', 'true');
        panel.querySelector('h3').focus({ preventScroll: true });
      };

      Object.entries(links).forEach(([key, link]) => {
        link.removeAttribute('target');
        link.removeAttribute('rel');
        link.href = `#${panels[key].id}`;
        link.setAttribute('aria-controls', panels[key].id);
        link.setAttribute('aria-expanded', 'false');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const isOpen = link.getAttribute('aria-expanded') === 'true';
          if (isOpen) closePanel(key);
          else openPanel(key);
        });
      });

      disclosures.querySelectorAll('[data-kuf-legal-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = button.closest('[data-kuf-legal-panel]');
          const key = panel.dataset.kufLegalPanel;
          closePanel(key);
          links[key].focus();
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMembershipLegal);
  else initMembershipLegal();
})();